/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, DropdownSelectField, Button } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { TranslatorContext } from '@jutro/locale';
import { Icon } from '@jutro/components';
import { accessibilityAddTableRow, focusNextElement, screenReaderAnnounce } from 'premier-capability-hooks';

import styles from './BoatMainEngineTableComponent.module.scss';
import metadata from './BoatMainEngineTableComponent.metadata.json5';
import messages from './BoatMainEngineTableComponent.messages';


function BoatMainEngineTableComponent(props) {

    const {
        data: mainEngineTableVM,
        updateWizardData,
        submissionVM,
        mainEngineTablePath,
        boatInformationPath,
        id: boatMainEngineId
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);


    const addMainEngineTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }


            mainEngineTableVM.value = mainEngineTableVM.value || []

            const MainEngineTableObjVM = viewModelService.create(
                {},
                "pc",
                "edgegen.capabilities.policyjob.lob.recmarproduct.coverables.dto.marinepleasurecraft.boats.subdto.MainEngineTableDTO"
            );

            MainEngineTableObjVM.isValidationReq = true;
            MainEngineTableObjVM.braFie = (_.get(submissionVM, boatInformationPath))?.value?.braFie;
            MainEngineTableObjVM.fueTypFie = { code: "Gas", name: "Gas" };
            MainEngineTableObjVM.yeaFie = (_.get(submissionVM, boatInformationPath))?.value?.yeaFie;

            mainEngineTableVM.pushElement(
                MainEngineTableObjVM
            );

            updateWizardData(submissionVM);
            
            accessibilityAddTableRow('Main Engine');
            setTimeout(() => {
                focusNextElement(true, 0, `${boatMainEngineId}yeaFie`);
            }, 3000);            
        },
        [mainEngineTableVM, viewModelService, submissionVM, boatInformationPath, updateWizardData]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeMainEngineItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            const removedMainEngine = mainEngineTableVM.value[index];

            mainEngineTableVM.value.splice(index, 1);
            _.set(submissionVM.value, mainEngineTablePath, mainEngineTableVM.value);
            updateWizardData(submissionVM);
            screenReaderAnnounce(translator(messages.removeMainEngine, {brandDesc: removedMainEngine.braFie}))
            focusNextElement(true,0, `addMainEngineTableBtnId`);
        }, [submissionVM, updateWizardData, mainEngineTablePath, mainEngineTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {
                let mainEngineArray = _.get(submissionVM, mainEngineTablePath);
                mainEngineArray = mainEngineArray.value
                const newNumber = mainEngineArray?.length >= 2 ? mainEngineArray[mainEngineArray.length - 2].numFie + 1 : index + 1;

                if (mainEngineArray[index].numFie === undefined) {
                    mainEngineArray[index].numFie = newNumber;
                    _.set(submissionVM.value, mainEngineTablePath, mainEngineTableVM.value);
                }

                const value = item.numFie ? item.numFie : newNumber;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'braFie') {
                const value = item[path] ? item[path] : (_.get(submissionVM, boatInformationPath))?.value?.braFie;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'serNumFie' || path === 'fueTypIfothplespeFie') {
                const value = item[path] ? item[path] : '';
                const disabled = path === 'fueTypIfothplespeFie' && (item['fueTypFie'] === undefined || item['fueTypFie'] !== "Other") ? true : false;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        disabled={disabled}
                        value={value}
                    />
                );
            }

            if (path === 'yeaFie') {
                const value = item[path] ? item[path] : (_.get(submissionVM, boatInformationPath))?.value?.yeaFie;

                return (
                    <InputField
                        id={index + boatMainEngineId+ path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            const filteredVal = String(val).replace(/[^0-9]/g, ''); // keep only digits

                            item[path] = filteredVal;
                            handleValueChange(filteredVal, changedPath, index);
                        }}
                        value={value}
                        maxLength="4"
                    />
                );
            }

            if (path === 'fueTypFie') {

                // eslint-disable-next-line security/detect-object-injection
                const availableValues = mainEngineTableVM.length > 0 && mainEngineTableVM.children[index].fueTypFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? mainEngineTableVM.children[index].fueTypFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                const value = item[path] ? item[path] : availableValues.filter((availableValue) => availableValue.code === 'Gas')[0];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'valFie') {
                const value = item[path] ? item[path] : '';
                const boatInfoValues = (_.get(submissionVM, boatInformationPath))?.value
                const isDisabled = boatInfoValues?.proTypFie !== 'JetOut'
                    && boatInfoValues?.proTypFie !== 'Out'
                    && boatInfoValues?.proTypFie !== 'Oth'

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        disabled={isDisabled}
                    />
                );
            }


        }, [submissionVM, mainEngineTablePath, mainEngineTableVM.value, mainEngineTableVM.length, mainEngineTableVM.children, boatInformationPath, handleValueChange, translator])

    const removeMainEngineTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeMainEngineItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeMainEngineItem, translator]
    );

 const renderAddButton = useCallback(() => (
          <Button type='button' id='addMainEngineTableBtnId' aria-label ={translator(messages.addMainEngine)} onClick={(e) => addMainEngineTable(e)}>
                    {translator(messages.add)}
                </Button>
        ), [addMainEngineTable, translator]);

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`MainEngineTableTable`]: {
            data: mainEngineTableVM && mainEngineTableVM.length > 0 ? mainEngineTableVM.value : []
        },
        'addMainEngineTablebtnDiv': {
            content: renderAddButton()
        }

    }), [mainEngineTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addMainEngineTable,
            getTableCell,
            removeMainEngineTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            mainEngineTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [mainEngineTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={mainEngineTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BoatMainEngineTableComponent.propTypes = wizardProps;
export default withRouter(BoatMainEngineTableComponent);
